import { render, staticRenderFns } from "./Retail.vue?vue&type=template&id=67991ea3&scoped=true&"
import script from "./Retail.vue?vue&type=script&lang=js&"
export * from "./Retail.vue?vue&type=script&lang=js&"
import style0 from "./Retail.vue?vue&type=style&index=0&id=67991ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67991ea3",
  null
  
)

export default component.exports